export type BadgeKind = 'ok' | 'crit' | 'warn' | 'info';

export function Badge({ kind, children }: { kind: BadgeKind; children: React.ReactNode }) {
  return <span className={`badge ${kind}`}>{children}</span>;
}
